import React, { useEffect, useMemo } from "react";
import { TextField } from "@mui/material";
import { useTableGlobalInvoicesConfig } from "./hooks";
import { useSelector } from "react-redux";
import { formatCustomDate } from "helpers/dateTools";

const toDate = (value) => new Date(value.replace(/-/g, "/"));

// Último día permitido: fin del mes de la fecha de inicio, sin pasar de hoy.
const getMaxValidDate = (startDate) => {
  const today = new Date();
  const date = toDate(startDate);
  const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  return lastDay >= today ? today : lastDay;
};

export const GlobalInvoicesSelectEndDate = () => {
  const { handleInputs } = useTableGlobalInvoicesConfig();
  const startDate = useSelector(({ globalInvoices }) => globalInvoices.startDate);
  const endDate = useSelector(({ globalInvoices }) => globalInvoices.endDate);

  const maxDate = useMemo(() => getMaxValidDate(startDate), [startDate]);

  useEffect(() => {
    const newEndDate = toDate(endDate);
    if (newEndDate > maxDate || toDate(startDate) > newEndDate)
      handleInputs("endDate", formatCustomDate(maxDate, "-"));
  }, [startDate, endDate, maxDate]);

  return (
    <TextField
      size="small"
      label="Fin"
      type="date"
      name="endDate"
      value={endDate}
      variant="outlined"
      InputLabelProps={{ shrink: true }}
      onChange={({ target: { name, value } }) => handleInputs(name, value)}
      inputProps={{
        min: startDate,
        max: formatCustomDate(maxDate, "-"),
      }}
      fullWidth
    />
  );
};
